import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getAccessDeniedMessage } from '../utils/permissions';

interface AccessDeniedProps {
  resource: string;
  className?: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ resource, className = '' }) => {
  const { user } = useAuth();
  
  return (
    <div className={`flex items-center justify-center min-h-[60vh] ${className}`}>
      <div className="max-w-md w-full bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center">
        {/* Access Denied Icon */}
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636 5.636 18.364" />
          </svg>
        </div>
        
        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Access Restricted</h2>
        
        {/* Message */}
        <p className="text-gray-600 mb-6 leading-relaxed">
          {getAccessDeniedMessage(user?.role, resource)}
        </p>
        
        {/* User Info */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <div className="text-sm text-gray-600">
            <span className="font-medium">Current Role:</span> {' '}
            <span className="capitalize font-semibold text-gray-900">
              {user?.role?.replace('_', ' ') || 'Unknown'}
            </span>
          </div>
          <div className="text-sm text-gray-600 mt-1">
            <span className="font-medium">User:</span> {user?.name || 'Unknown User'}
          </div>
        </div>
        
        {/* Help text */}
        <p className="text-sm text-gray-500">
          If you need access to this feature, please contact your system administrator.
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;